/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PagedResultDto_CsSellItemDto } from '../models/PagedResultDto_CsSellItemDto';
import type { Wealthlane_AwardService_Dtos_BrokerTradeTool_CreateExecutedDoneTradeDto } from '../models/Wealthlane_AwardService_Dtos_BrokerTradeTool_CreateExecutedDoneTradeDto';
import type { Wealthlane_AwardService_Dtos_BrokerTradeTool_ExecutedDoneTradeResponseDto } from '../models/Wealthlane_AwardService_Dtos_BrokerTradeTool_ExecutedDoneTradeResponseDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class CsDoneTradeToolService {
  /**
   * GET /api/award/api/app/cs/done-trade-tool/api/app/long-share/cs-long-shares-list-for-vendor
   * @returns PagedResultDto_CsSellItemDto OK
   * @throws ApiError
   */
  public static getApiAwardApiAppCsDoneTradeToolCsLongSharesListForVendor(
    participantId?: string,
    companyId?: string,
    skipCount?: number,
    maxResultCount: number = 10,
    awardType?: string
  ): CancelablePromise<PagedResultDto_CsSellItemDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/award/api/app/cs/done-trade-tool/api/app/long-share/cs-long-shares-list-for-vendor',
      query: {
        participantId,
        companyId,
        skipCount,
        maxResultCount,
        awardType,
      },
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
        500: `Internal Server Error`,
        501: `Not Implemented`,
      },
    });
  }

  /**
   * POST /api/award/api/app/cs/done-trade-tool/create-executed-long-share-sell
   * @returns Wealthlane_AwardService_Dtos_BrokerTradeTool_ExecutedDoneTradeResponseDto OK
   * @throws ApiError
   */
  public static postApiAwardApiAppCsDoneTradeToolCreateExecutedLongShareSell(
    requestBody?: Wealthlane_AwardService_Dtos_BrokerTradeTool_CreateExecutedDoneTradeDto
  ): CancelablePromise<Wealthlane_AwardService_Dtos_BrokerTradeTool_ExecutedDoneTradeResponseDto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/award/api/app/cs/done-trade-tool/create-executed-long-share-sell',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
        500: `Internal Server Error`,
        501: `Not Implemented`,
      },
    });
  }
}
